import React from 'react';
import 'antd/dist/antd.css';
import { Modal } from 'antd';
const { confirm } = Modal;


function ModalAdd(props) {


    const ConfirmModal = () => {
        return (
            confirm({
                title: props.title,
                content: props.content,
                okText: props.okText,
                cancelText: props.cancelText,
                onOk() {
                  },
                  onCancel() {
                  },
              })
        )
    }

    return (
        <div>
            {ConfirmModal()}
        </div>
    );
}

export default ModalAdd;
